import { PRESENTATIONS } from '../../constants';
export const visibleByCondition = {
    name: PRESENTATIONS.visible,
    condition: {
        showIf: true,
    },
};
